import { Switch, Route } from "react-router";
import { BaseRoute } from "Components";
import { useRouteMatch } from "react-router";

import List from "./List";
import New from "./New";

export default () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/new`}>
        <New />
      </Route>
      <Route exact={true}>
        <List />
      </Route>
    </Switch>
  );
};
